import { Eye, EyeOff } from 'lucide-react';
import { type ComponentProps, forwardRef, type ReactNode, useState } from 'react';
import FieldLabelMobile from '@/domains/mobile-web/components/FieldLabelMobile/FieldLabelMobile';
import { cn } from '@/lib/utils';

export interface PasswordMobileProps extends Omit<ComponentProps<'input'>, 'className' | 'type'> {
  label?: string;
  error?: string;
  helperText?: string;
  /** Shown at the right end of the label row (a link such as "Lupa Password?") */
  labelAction?: ReactNode;
  /** class untuk pembungkus (label + field) */
  className?: string;
  /** class tambahan untuk elemen input */
  inputClassName?: string;
}

/** Password field in the mobile style with a show/hide toggle on the right */
const PasswordMobile = forwardRef<HTMLInputElement, PasswordMobileProps>(
  (
    {
      label,
      error,
      helperText,
      labelAction,
      className,
      inputClassName,
      id,
      name,
      required,
      disabled,
      ...props
    },
    ref
  ) => {
    const [visible, setVisible] = useState(false);
    const inputId = id ?? name;

    return (
      <FieldLabelMobile
        label={label}
        htmlFor={inputId}
        required={required}
        error={error}
        helperText={helperText}
        labelAction={labelAction}
        className={className}
      >
        <div className="relative w-full">
          <input
            ref={ref}
            id={inputId}
            name={name}
            type={visible ? 'text' : 'password'}
            required={required}
            disabled={disabled}
            aria-invalid={!!error}
            className={cn('field-mobile pr-11', error && 'field-mobile-error', inputClassName)}
            {...props}
          />
          <button
            type="button"
            onClick={() => setVisible((current) => !current)}
            disabled={disabled}
            aria-label={visible ? 'Sembunyikan password' : 'Tampilkan password'}
            aria-pressed={visible}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-black disabled:opacity-50"
          >
            {visible ? <EyeOff className="size-5" /> : <Eye className="size-5" />}
          </button>
        </div>
      </FieldLabelMobile>
    );
  }
);

PasswordMobile.displayName = 'PasswordMobile';

export default PasswordMobile;
